<template>
  <div class="row relatorios">
    <div class="col-md-12">
      <h1 class="h3 mb-3 text-gray-800">Relatório</h1>
      <p>
        Os dados nas páginas de gráficos e filtros só exibem registros com os
        campos devidamente preenchidos.
      </p>
    </div>
    <load v-if="loading" />
    <div class="col-md-12" v-else>
      <b-card-group deck class="mt-4">
        <ReportCard
          :condicao="
            ($store.state.user.permissions &&
              $store.state.user.permissions['RelatorioAcessoController']) ||
            $store.state.user.role_details.name == 'Admin' ||
            $store.state.user.role_details.name == 'Gestor(a)'
          "
          titulo="Acesso"
          :counts="counts.Acessos"
          rota="/dashboard/relatorios/acessos"
          icone="fas fa-chart-bar"
        />

        <ReportCard
          :condicao="
            $store.state.user.permissions &&
            $store.state.user.permissions['RelatorioAcolhimentoController']
          "
          titulo="Acolhimento"
          :counts="counts.Acolhimento"
          rota="/dashboard/relatorios/acolhimentos"
          icone="fas fa-bed"
        />

        <ReportCard
          :condicao="
            $store.state.user.permissions &&
            $store.state.user.permissions['RelatorioPafController']
          "
          titulo="Acompanhamento"
          :counts="counts.PAF"
          rota="/dashboard/relatorios/acompanhamentos"
          icone="fas fa-user-tag"
        />

        <ReportCard
          :condicao="
            $store.state.user.permissions &&
            $store.state.user.permissions['RelatorioAtendimentoController']
          "
          titulo="Atendimento"
          :counts="counts.Atendimento"
          rota="/dashboard/relatorios/atendimentos"
          icone="fas fa-hands-helping"
        />
      </b-card-group>

      <b-card-group deck class="mt-4">
        <ReportCard
          :condicao="
            $store.state.user.permissions &&
            $store.state.user.permissions['RelatorioAtividadeController']
          "
          titulo="Atividade"
          :counts="counts.Atividade"
          rota="/dashboard/relatorios/atividades"
          icone="mdi mdi-clipboard-text mdi-48px"
        />

        <ReportCard
          :condicao="
            ($store.state.user.permissions &&
              $store.state.user.permissions['AuditoriaController']) ||
            $store.state.user.role_details.name == 'Admin' ||
            $store.state.user.role_details.name == 'Gestor(a)'
          "
          titulo="Auditoria"
          :counts="counts.Audits"
          rota="/dashboard/auditorias"
          icone="mdi mdi-file-search-outline"
        />

        <ReportCard
          :condicao="
            $store.state.user.permissions &&
            $store.state.user.permissions['RelatorioBeneficioController']
          "
          titulo="Benefício"
          :counts="counts.Beneficio"
          rota="/dashboard/relatorios/beneficios"
          icone="mdi mdi-account-cash mdi-48px"
        />

        <ReportCard
          :condicao="
            $store.state.user.permissions &&
            $store.state.user.permissions['RelatorioDenunciaController']
          "
          titulo="Denúncia"
          :counts="counts.Denuncia"
          rota="/dashboard/relatorios/denuncias"
          icone="mdi mdi-shield-alert mdi-48px"
        />
      </b-card-group>

      <b-card-group deck class="mt-4">
        <ReportCard
          :condicao="
            $store.state.user.permissions &&
            $store.state.user.permissions['RelatorioEncaminhamentoController']
          "
          titulo="Encaminhamento"
          :counts="counts.Encaminhamento"
          rota="/dashboard/relatorios/encaminhamentos"
          icone="fas fa-share-square"
        />

        <ReportCard
          :condicao="
            $store.state.user.permissions &&
            $store.state.user.permissions['FamiliaReportController']
          "
          titulo="Família"
          :counts="counts.Familia"
          rota="/dashboard/relatorios/familias"
          icone="mdi mdi-account-group mdi-48px"
        />

        <ReportCard
          :condicao="
            $store.state.user.permissions &&
            $store.state.user.permissions['RelatorioMedidaController']
          "
          titulo="Medida Socioeducativa"
          :counts="counts.MedidasSocioeducativa"
          rota="/dashboard/relatorios/medidas"
          icone="fas fa-university"
        />

        <ReportCard
          :condicao="
            $store.state.user.permissions &&
            $store.state.user.permissions['RelatorioOficioController']
          "
          titulo="Ofício"
          :counts="counts.Oficio"
          rota="/dashboard/relatorios/oficios"
          icone="mdi mdi-file-document-multiple mdi-48px"
        />
      </b-card-group>

      <b-card-group deck class="mt-4">
        <ReportCard
          :condicao="
            $store.state.user.permissions &&
            $store.state.user.permissions['RelatorioProgramaSocialController']
          "
          titulo="Programa Social"
          :counts="counts.ProgramaSocial"
          rota="/dashboard/relatorios/programassociais"
          icone="fas fa-hands"
        />

        <ReportCard
          :condicao="
            $store.state.user.permissions &&
            $store.state.user.permissions['RelatorioReferenciamentoController']
          "
          titulo="Referência e Contrarreferência"
          :counts="counts.Referencia"
          rota="/dashboard/relatorios/referenciamentos"
          icone="fas fa-retweet"
        />

        <ReportCard
          :condicao="
            $store.state.user.role_details.name == 'Admin' ||
            $store.state.user.role_details.name == 'Gestor(a)'
          "
          titulo="Relatório do Gestor"
          counts="none"
          rota="/dashboard/relatorio/RMA?tipo=gestor"
          icone="mdi mdi-file-search-outline"
        />

        <ReportCard
          :condicao="
            $store.state.user.permissions &&
            $store.state.user.permissions['RelatorioController']
          "
          titulo="RMA"
          counts="none"
          rota="/dashboard/relatorio/RMA"
          icone="mdi mdi-file-search-outline"
        />
      </b-card-group>

      <b-card-group deck class="mt-4">
        <ReportCard
          :condicao="
            $store.state.user.permissions &&
            $store.state.user.permissions['SituacaoPrioritariaController']
          "
          titulo="SCFV"
          :counts="counts.ScfvGrupo"
          rota="/dashboard/relatorios/scfv"
          icone="mdi mdi-google-circles-extended mdi-48px"
        />

        <ReportCard
          :condicao="
            $store.state.user.permissions &&
            $store.state.user.permissions['RelatorioTecnicoController']
          "
          titulo="Técnico"
          :counts="counts.Tecnico"
          rota="/dashboard/relatorios/tecnicos"
          icone="fas fa-user-edit"
        />

        <ReportCard
          :condicao="
            $store.state.user.permissions &&
            $store.state.user.permissions['RelatorioUnidadeController']
          "
          titulo="Unidade"
          :counts="counts.Unidade"
          rota="/dashboard/relatorios/unidades"
          icone="fas fa-house-user"
        />

        <ReportCard
          :condicao="
            $store.state.user.permissions &&
            $store.state.user.permissions['UsuarioReportController']
          "
          titulo="Usuário"
          :counts="counts.Usuario"
          rota="/dashboard/relatorios/usuarios"
          icone="mdi mdi-account mdi-48px"
        />

        <ReportCard
          :condicao="
            $store.state.user.permissions &&
            $store.state.user.permissions[
              'RelatorioViolenciaViolacaoDireitoController'
            ]
          "
          titulo="Violação de Direitos na Família"
          :counts="counts.ViolenciaViolacaoDireito"
          rota="/dashboard/relatorios/violacaodedireitos"
          icone="fas fa-exclamation-triangle"
        />

        <ReportCard
          :condicao="
            $store.state.user.role_details.name == 'Gestor(a)' ||
            $store.state.user.role_details.name == 'Admin'
          "
          titulo="SUAS Fácil"
          rota="/dashboard/relatorios/suasfacil"
          counts="none"
          icone="fas fa-solid fa-binoculars"
        />
      </b-card-group>
    </div>
  </div>
</template>
<script>
import ReportCard from "./includes/components/ReportCard";
export default {
  components: {
    ReportCard,
  },
  data() {
    return { loading: false, counts: {} };
  },
  mounted() {
    this.countData();
  },
  methods: {
    redirectVVD() {
      this.$router.push(`/dashboard/relatorios/violacaodedireitos`);
    },
    async countData() {
      this.loading = true;
      await axios
        .get("/api/dashboard/relatorio/counts")
        .then((response) => {
          this.counts = response.data;
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style>
.relatorios .card {
  box-shadow: 0 0 35px 0 rgb(154 161 171 / 15%) !important;
}
.relatorios .card:hover {
  box-shadow: 0 0 35px 0 rgb(154 161 171 / 35%) !important;
}

.relatorios a.disabled {
  cursor: not-allowed;
  color: #ccc;
}
</style>
